import { render, staticRenderFns } from "./qa-answer.vue?vue&type=template&id=747fdcf7&scoped=true&"
import script from "./qa-answer.vue?vue&type=script&lang=js&"
export * from "./qa-answer.vue?vue&type=script&lang=js&"
import style0 from "./qa-answer.vue?vue&type=style&index=0&id=747fdcf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747fdcf7",
  null
  
)

export default component.exports